<template>
  <div id="app" v-cloak>
    <transition name="slide-fade">
      <router-view class="page"></router-view>
    </transition>
  </div>
</template>

<script>
export default {
  name: "App",
  data(){
    return{
      isRouteAlive: true
    }
  },
  provide () {
    return {
      reload: this.reload
    }
  },
  watch: {
    '$route' (to, from) {}
  },
  mounted() {
    // 页面跳转后，回滚到最顶部
    // document.addEventListener("touchstart", function() {},false);
    // this.$router.afterEach((to, from, next) => {
    //   window.scrollTo(0, 0)
    // })
  },
  methods:{

  }
};
</script>

<style  lang="scss">
@import "./styles/reset";
@import "./styles/global";
[v-cloak] {
  display: none;
}
#app {
  position: relative;
  width: 100%;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  background: #fff;
  img {
    max-width: 100%;
    vertical-align: middle;
  }
}
.tiem-label{
  // display: block;
  color: #409eff;
  padding: 0 5px;
  flex-shrink: 0;
  cursor: pointer;
}
.flex-between{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
// 
.operation-menu{
  padding: 20px 0;
  .btn{
    margin-right: 10px;
  }
}
</style>
